export default "__VITE_ASSET__6192c47c__"